import { Staffs, CompatibleRolesFilter } from '../../../types';

export default class StaffState {
  current_staff: Staffs.Staff = {} as Staffs.Staff;

  editable_staff: Staffs.Staff = {} as Staffs.Staff;

  compatible_roles: Staffs.CompatibleRoles[] = [];

  filters: CompatibleRolesFilter = {
    roles: [],
  }

  roles_loading = false;
}
